import { Component, OnInit } from '@angular/core';
import { MainService } from '../../service/main.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../../service/local-storage.service';
import { ToasterServiceService } from '../../service/toaster.service';
import { ApiUrls } from '../../apiRouts';
import { ConfirmDialog } from '../../shared/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-event-donor-list',
  templateUrl: './event-donor-list.component.html',
  styleUrl: './event-donor-list.component.scss'
})
export class EventDonorListComponent implements OnInit{
  getEventDonorListMain: any;
  getEventDonorList: any;
  subEventId:any;
  userTypeId:any;
  label:any;
  constructor(
    private mainService: MainService,
    private router: Router,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private toasterService: ToasterServiceService,
    public dialog: MatDialog
  ) {
    this.userTypeId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_type_id;
    this.route.params.subscribe((params: any) => {
      this.subEventId =  params['sub_event_id'] || '';
    });
  }
  
  ngOnInit(): void {
    this.getSubEventDonorData();
  }

  getSubEventDonorData(){
    this.mainService.getApi(ApiUrls.getSubEventDonorList+  this.subEventId ).subscribe(res => {
      if(this.userTypeId == 1){
      this.getEventDonorListMain = res.sub_event_donor;
      this.getEventDonorList = res.sub_event_donor;
      }else{
        this.getEventDonorListMain = res.sub_event_donor.filter((x:any) => x.is_active == 1);
        this.getEventDonorList = res.sub_event_donor.filter((x:any) => x.is_active == 1);
      }
    })
  }

  addEventDonor(){
    this.router.navigate(["/add-event-donor/" + this.subEventId]);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.getEventDonorList = this.getEventDonorListMain
      return;
    }
    this.getEventDonorList = this.getEventDonorListMain.filter((user: any) => {
      return user.member_name.toLowerCase().includes(filterValue)
    });
  }

  openDialog(e: any, data: any): void {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        page: 'JobList'
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.deleteDonor(data);
      } else {
        e.source.checked = !e.checked;
        data.status = e.checked == true ? 0 : 1;
      }
    });
  }

  deleteDonor(data:any){
    var obj: any = {
      sub_event_donor_id: Number(data.sub_event_donor_id),
      sub_event_id: 0,
      created_by: 0,
      user_ids_json:'[]',
      Action: 'STATUS'
    }
    this.mainService.postApi(ApiUrls.addEventDonor, obj, 1).subscribe(res => {
      if (res.status == 1) {
        this.toasterService.toastSuccess(res.response);
        this.getSubEventDonorData();
      } else {
        this.toasterService.toastError(res.response);
      }
    })
  }
}
